import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";

import type { PostRetryFailedIntegrationStepRequestDto } from "../../dtos/post-retry-failed-integration-step-request-dto";
import type { PostRetryFailedIntegrationStepResponseDto } from "../../dtos/post-retry-failed-integration-step-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UsePostRetryFailedIntegrationStepMutationProps = {
  options?: UseMutationOptions<
    PostRetryFailedIntegrationStepResponseDto,
    unknown,
    PostRetryFailedIntegrationStepRequestDto
  >;
};

export const usePostRetryFailedIntegrationStepMutation = ({
  options
}: UsePostRetryFailedIntegrationStepMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) =>
      await OrderService.postRetryFailedIntegrationStep({ payload }),
    ...options,
    onSuccess: async (...args) => {
      const [, variables] = args;

      await queryClient.invalidateQueries({
        queryKey: OrderQueryKeys.getIntegrationStatus(variables.orderId)
          .queryKey
      });

      options?.onSuccess?.(...args);
    }
  });
};
